export enum SlackActionType {
  UPDATE_RECORD = 'UPDATE_RECORD',
  CREATE_RECORD = 'CREATE_RECORD',
  UPDATE__RELATED_RECORD = 'UPDATE__RELATED_RECORD', // Not supported yet
  LINK_BUTTON = 'LINK_BUTTON',
}
